/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_8_HInputs */

const en_terms_8_h = /** @type {(inputs: Terms_8_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termination`)
};

const id_terms_8_h = /** @type {(inputs: Terms_8_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghentian`)
};

/**
* | output |
* | --- |
* | "Termination" |
*
* @param {Terms_8_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_8_h = /** @type {((inputs?: Terms_8_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_8_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_8_h(inputs)
	return en_terms_8_h(inputs)
});